import React, { Component } from 'react'
import { Row, Col, Container, Table, Form } from "react-bootstrap";
import moment from "moment";
import DateBlock from '../home/DateBlock';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import "./_studentPermission.scss"
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import PermissionDetailsModal from './PermissionDetailsModal';
import MultipleRequestModal from './MultipleRequestModal';
import SingleRequestModal from './SingleRequestModal';
import PermissionModal from './studentPermissionModal';
import { StudentPermissionShimmer } from './StudentPermissionShimmer';
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../utils/moduleGuard";
import {
  getAuthorizedBranchIds,
  getAuthorizedSectionIds,
  getAuthorizedClassIds,
  filterByAuthorizedIds,
} from "../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

// /student-permission → "Permissions" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const PERMISSIONS_MODULE = ["Permissions"];

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.ref = React.createRef();
  }

  componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
  componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }

  handleOutside = (e) => {
    if (this.ref.current && !this.ref.current.contains(e.target))
      this.setState({ open: false });
  };

  toggle = (id) => {
    const { value, onChange } = this.props;
    const exists = value.includes(id);
    onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
  };

  render() {
    const { options, value, placeholder, onChange } = this.props;
    const { open } = this.state;
    const label = value.length === 0
      ? placeholder
      : value.length === options.length
        ? `All (${options.length})`
        : value.length === 1
          ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
          : `${value.length} selected`;

    return (
      <div ref={this.ref} style={{ position: "relative" }}>
        <div onClick={() => this.setState({ open: !open })}
          style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "8px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
          <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
        </div>

        {open && (
          <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
            {options.length === 0 ? (
              <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
            ) : (
              <>
                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                  style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                  <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                  Select All
                </div>
                {options.map((o) => (
                  <div key={o.value} onClick={() => this.toggle(o.value)}
                    style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

class StudentPermissionHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // data sources (finance pattern)
      branches: [],
      getClasses: [],
      // multi-select filters
      branchSearch: [],
      classSearch: [],
      sectionSearch: [],
      // request type (single)
      permissiontypeSearch: "0",
      // status filter for the table view
      blockType: "1",
      // events view date range
      startDateCalender: moment(new Date()).subtract(5, "days").startOf('day').unix(),
      endDateCalender: moment(new Date()).endOf('day').unix(),
      // modals
      viewDetailsModal: false,
      viewMultipleRequestModal: false,
      viewSingleRequestModal: false,
      permissionModalShow: false,
      individualPermissionData: [],
      sendStudentsNotificationList: [],
      template_name: "",
      initialLoad: true,
      accessDeniedShow: false,
    }

    this.guard = attachModuleGuard(this, PERMISSIONS_MODULE);
  }

  // Every write on this page happens inside a child modal (SingleRequestModal creates a
  // permission, PermissionDetailsModal approves/declines it, PermissionModal sends
  // parent notifications). This component owns nothing but the flags that open them, so
  // gating the openers covers the whole write surface without touching the modals.
  //
  // The buttons stay visible and clickable — the click is allowed through, the grant is
  // checked, and a missing grant opens the Access Denied modal instead of the child.
  openSingleRequestModal = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ viewSingleRequestModal: true });
  };

  // The row action is labelled "View", but the modal it opens is where a request is
  // APPROVED or DECLINED — so it's an is_edit action, not a read.
  openPermissionDetailsModal = (row) => {
    if (!this.guard.requireEdit()) return;
    this.setState({
      viewDetailsModal: true,
      individualPermissionData: row.individualPermissionData,
    });
  };

  // Sending parent notifications is a write → is_edit. Shared by the five event-view
  // cells (Total / Present / Exited / Returned / Not Back), which differ only in how
  // they filter the rows and which template they use.
  openPermissionNotifyModal = (rows, template_name) => {
    if (!rows.length) return;
    if (!this.guard.requireEdit()) return;
    this.setState({
      permissionModalShow: true,
      sendStudentsNotificationList: rows,
      template_name,
    });
  };

  async componentDidMount() {
    // is_view === 0 → don't fetch anything. getBranches/getClasses are imperative
    // client.query() calls, so the `skip` on the parent's graphql HOCs doesn't cover
    // them — they have to be bailed out of here or the data still loads. render()
    // returns Access Denied before it reads initialLoad, so leaving it true is fine.
    if (!this.guard.canView()) return;

    // default request type = first available type
    const types = this.props.getPermissionRequestTypes || [];
    if (types.length > 0) {
      // Descending order → College Request (highest id) shows first / is default.
      const sorted = [...types].sort((a, b) => b.id - a.id);
      this.setState({ permissiontypeSearch: sorted[0].id });
    }

    await Promise.all([this.getBranches(), this.getClasses()]);
    this.setState({ initialLoad: false });
    // Branch comes from the header (NavbarOne) — re-scope when it changes.
    this.offBranchScope = onBranchScopeChange(() => this.getBranches());
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  getBranches = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_BRANCHES,
        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: "network-only",
      });
      // The header's branch selection (NavbarOne) IS this page's branch filter.
      let branches = scopeBranches(result.data.getBranches || []);

      // restrict to the user's authorized sections/classes for non-admin levels. The
      // *_id cookies are comma-separated lists (e.g. "10,12,15"), so an exact ===
      // against the whole cookie matched nothing for multi-value users → empty
      // dropdowns / no data. An empty cookie means that dimension was never assigned,
      // so it stays unrestricted (see authHelper.js).
      if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
        const authorizedSectionIds = getAuthorizedSectionIds();
        const authorizedClassIds = getAuthorizedClassIds();
        branches = branches.map(b => {
          let sections = b.sections || [];
          if (authorizedSectionIds.length) {
            sections = filterByAuthorizedIds(sections, authorizedSectionIds, "id");
          }
          if (authorizedClassIds.length) {
            sections = filterByAuthorizedIds(sections, authorizedClassIds, "class_id");
          }
          return { ...b, sections };
        });
      }

      const allBranchIds = branches.map(b => b.id);
      const allSectionIds = branches.flatMap(b => b.sections || []).map(s => s.id);
      const allClassIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => Number(s.class_id))));
      this.setState({
        branches,
        branchSearch: allBranchIds,
        classSearch: allClassIds,
        sectionSearch: allSectionIds,
      });
    } catch {
      // ignore
    }
  };

  getClasses = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_CLASSES,
        variables: { id: 1 },
        fetchPolicy: "network-only",
      });
      this.setState({ getClasses: result.data.getExamClasses || [] });
    } catch {
      // ignore
    }
  };

  tableData(students) {
    const student_data = Array();
    for (let i = 0; i < students.length; i++) {
      student_data.push({
        id: students[i].permission_id,
        student_name: students[i].student_name,
        branch_name: students[i].branch_name,
        class_name: students[i].class_name,
        section_name: students[i].section_name,
        student_roll_no: students[i].roll_no,
        parent_name: students[i].parent_name,
        parent_mobile: students[i].parent_mobile,
        request_message: students[i].request_message,
        request_date: students[i].request_date ? moment.unix(students[i].request_date).format("DD-MM-YYYY hh:mm A") : "--",
        individualPermissionData: students[i]
      });
    }
    return student_data;
  }

  articlecolumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
      formatter: (val) => (
        <span style={{ fontWeight: 700, color: "#1E293B", display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
          <i className="fas fa-user-graduate" style={{ color: "#6366F1", fontSize: 13 }} />
          {val}
        </span>
      )
    },
    {
      dataField: "student_roll_no",
      text: "Roll No.",
      sort: true,
      formatter: (val) => (
        <span className="badge-roll">{val}</span>
      )
    },
    {
      dataField: "parent_name",
      text: "Parent Name",
      sort: true,
      formatter: (val) => (
        <span style={{ color: "#334155", display: "flex", alignItems: "center", gap: 5, justifyContent: "center", whiteSpace: "nowrap" }}>
          <i className="fas fa-user" style={{ color: "#64748B", fontSize: 11 }} />{val}
        </span>
      )
    },
    {
      dataField: "parent_mobile",
      text: "Parent Mobile",
      sort: true,
      formatter: (val) => (
        <span style={{ color: "#334155", display: "flex", alignItems: "center", gap: 5, justifyContent: "center" }}>
          <i className="fas fa-phone" style={{ color: "#10B981", fontSize: 11 }} />{val}
        </span>
      )
    },
    {
      dataField: "request_message",
      text: "Request Message",
      sort: false,
      formatter: (val) => (
        <span
          title={val || ""}
          style={{ color: "#475569", display: "inline-flex", alignItems: "center", gap: 6, maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: val ? "help" : "default" }}
        >
          <i className="fas fa-comment-alt" style={{ color: "#94A3B8", fontSize: 11, flexShrink: 0 }} />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{val || "--"}</span>
        </span>
      )
    },
    {
      dataField: "branch_name",
      text: "Branch",
      sort: true,
      formatter: (val) => <span className="badge-branch">{val}</span>
    },
    {
      dataField: "class_name",
      text: "Class",
      sort: true,
      formatter: (val) => <span className="badge-class">{val}</span>
    },
    {
      dataField: "section_name",
      text: "Section",
      sort: true,
      formatter: (val) => <span className="badge-section">{val}</span>
    },
    {
      dataField: "request_date",
      text: "Request Date",
      sort: true,
      formatter: (val) => (
        <span className="badge-date">
          <i className="fas fa-calendar-day" style={{ marginRight: 5, color: "#64748B" }} />{val}
        </span>
      )
    },
    {
      dataField: "View Details",
      formatter: this.performanceFunc.bind(this),
      text: "Action",
      classes: "perm-sticky-action",
      headerClasses: "perm-sticky-action-head"
    },
  ];

  performanceFunc(val, row) {
    return (
      <div className="d-flex justify-content-center">
        <button
          className="perm-view-btn"
          onClick={() => this.openPermissionDetailsModal(row)}
        >
          <i className="fas fa-eye" />
          View
        </button>
      </div>
    );
  }

  applyCallback = (startDate, endDate) => {
    this.setState({
      startDateCalender: startDate.startOf('day').unix(),
      endDateCalender: endDate.endOf('day').unix(),
    })
  }

  render() {
    // is_view === 0 → the permission data is never rendered, and the two queries in
    // StudentPermission.jsx are skipped so nothing is fetched. Deliberately ABOVE the
    // initialLoad shimmer: a denied user should see Access Denied immediately, not a
    // loading skeleton for data that will never arrive.
    if (!this.guard.canView()) {
      return <AccessDeniedCard />;
    }

    if (this.state.initialLoad) {
      return <StudentPermissionShimmer />;
    }

    const { branches, getClasses, branchSearch, classSearch, sectionSearch } = this.state;

    // ── derive cascading dropdown options (branch → class → section) ──
    const selectedBranchObjs = branchSearch.length > 0
      ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id)))
      : branches;

    const classOptions = Array.from(new Set(selectedBranchObjs.flatMap(b => b.sections || []).map(s => Number(s.class_id))))
      .map(cid => getClasses.find(c => c.id === cid)).filter(Boolean)
      .map(c => ({ value: c.id, label: c.class }));

    const sectionOptions = selectedBranchObjs
      .flatMap(b => b.sections || [])
      .filter(s => classSearch.length === 0 || classSearch.map(Number).includes(Number(s.class_id)))
      .map(s => ({ value: s.id, label: s.section_name }));

    const permissionTypes = this.props.getPermissionRequestTypes || [];

    // ── apply branch / class / section filters ──
    let StudentsFilterData = this.props.getParentsPermissionDetails || [];
    if (branchSearch.length > 0) {
      StudentsFilterData = StudentsFilterData.filter(a => branchSearch.map(Number).includes(Number(a.branch_id)));
    }
    if (classSearch.length > 0) {
      StudentsFilterData = StudentsFilterData.filter(a => classSearch.map(Number).includes(Number(a.class_id)));
    }
    if (sectionSearch.length > 0) {
      StudentsFilterData = StudentsFilterData.filter(a => sectionSearch.map(Number).includes(Number(a.section_id)));
    }

    // ── events data (request type = events / "2") ──
    let eventData = StudentsFilterData.filter((item) => item.request_title != null && item.request_title != "" && parseInt(item.from_datetime) > +this.state.startDateCalender && parseInt(item.from_datetime) < +this.state.endDateCalender);
    const uniqueEventsDates = [...new Set(eventData.map((item) => item.from_datetime))];

    // ── request type filter ──
    let permissionRequestType = this.state.permissiontypeSearch != "0"
      ? StudentsFilterData.filter((a) => a.permission_request_type_id == this.state.permissiontypeSearch)
      : StudentsFilterData;

    // ── status filter for the table view ──
    let permissionFilterData = [];
    if (this.state.blockType == "1") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == null);
    } else if (this.state.blockType == "2") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == "1");
    } else if (this.state.blockType == "3") {
      permissionFilterData = permissionRequestType.filter((item) => item.permission_status == "2");
    }

    // Only the actual "events" request type shows the aggregate events view;
    // other types (e.g. parent / college request) show the normal status table.
    const selectedRequestType = permissionTypes.find(t => String(t.id) === String(this.state.permissiontypeSearch));
    const isEventsView = !!(selectedRequestType && /event/i.test(selectedRequestType.permission_request_type || ""));
    // College permission is staff-created and granted immediately — there is no
    // pending / decline flow, so hide the status cards and just list every record.
    const isCollegeView = !!(selectedRequestType && /college/i.test(selectedRequestType.permission_request_type || ""));
    const statusTableRows = isCollegeView ? permissionRequestType : permissionFilterData;

    // ── finance-style inline styles ──
    const S = {
      wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
      card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" },
      cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
      iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
      cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
      cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
      cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
      headerActions: { display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" },
      btnPrimary: { display: "inline-flex", alignItems: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "9px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
      btnOutline: { display: "inline-flex", alignItems: "center", gap: 7, background: "#f5f3ff", color: "#7c3aed", border: "1px solid #ddd6fe", borderRadius: 9, padding: "9px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
      filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
      filterLabel: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
      select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "8px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%" },
      content: { padding: "20px 24px" },
    };

    // ── status cards config ──
    const statusCards = [
      { key: "1", label: "Requested", icon: "fas fa-clock", count: permissionRequestType.filter(i => i.permission_status == null).length, tint: "#fffbeb", border: "#fde68a", color: "#d97706" },
      { key: "2", label: "Accepted", icon: "fas fa-check-circle", count: permissionRequestType.filter(i => i.permission_status == "1").length, tint: "#ecfdf5", border: "#a7f3d0", color: "#059669" },
      { key: "3", label: "Declined", icon: "fas fa-times-circle", count: permissionRequestType.filter(i => i.permission_status == "2").length, tint: "#fef2f2", border: "#fecaca", color: "#dc2626" },
    ];

    return (
      <div className="student-permission-finance" style={S.wrapper}>
        <Container fluid className="px-0">
          <div style={S.card}>

            {/* ── Card header ── */}
            <div style={S.cardHeader}>
              <div style={S.iconWrapper}>
                <i className="fal fa-shield-alt" />
              </div>
              <div style={S.cardTitleText}>
                <h5 style={S.cardTitle}>Student Permissions</h5>
                <span style={S.cardSubtitle}>Manage student outpass &amp; permission requests</span>
              </div>
              <div style={S.headerActions}>
                <button style={S.btnPrimary} onClick={this.openSingleRequestModal}>
                  <i className="fas fa-user-plus" /> New Permission
                </button>
                {/* Multi Request hidden per requirement
                <button style={S.btnPrimary} onClick={() => this.setState({ viewMultipleRequestModal: true })}>
                  <i className="fas fa-users" /> Multi Request
                </button>
                */}
              </div>
            </div>

            {/* ── Filter bar ── */}
            <div style={S.filterBar}>
              <Row className="g-2">
                {/* No Branch filter — the header's branch selection scopes this list. */}
                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                  <label style={S.filterLabel}>Class</label>
                  <CheckboxDropdown
                    options={classOptions}
                    value={classSearch}
                    onChange={(val) => {
                      if (val.length === 0) {
                        this.setState({ classSearch: [], sectionSearch: [] });
                        return;
                      }
                      const selBranches = branchSearch.length > 0 ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id))) : branches;
                      const newSectionIds = selBranches.flatMap(b => b.sections || [])
                        .filter(s => val.map(Number).includes(Number(s.class_id)))
                        .map(s => s.id);
                      this.setState({ classSearch: val, sectionSearch: newSectionIds });
                    }}
                    placeholder="All Classes"
                  />
                </Col>
                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                  <label style={S.filterLabel}>Section</label>
                  <CheckboxDropdown
                    options={sectionOptions}
                    value={sectionSearch}
                    onChange={(val) => this.setState({ sectionSearch: val })}
                    placeholder="All Sections"
                  />
                </Col>
                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                  <label style={S.filterLabel}>Request Type</label>
                  <select
                    style={S.select}
                    value={this.state.permissiontypeSearch}
                    onChange={(e) => this.setState({ permissiontypeSearch: e.target.value })}
                  >
                    {[...permissionTypes].sort((a, b) => b.id - a.id).map((t) => (
                      <option key={t.id} value={t.id}>{t.permission_request_type}</option>
                    ))}
                  </select>
                </Col>
              </Row>
            </div>

            {/* ── Content ── */}
            <div style={S.content}>
              {isEventsView ? (
                /* ── Events view ── */
                <>
                  <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap" style={{ gap: 12 }}>
                    <h6 style={{ fontWeight: 700, color: "#1E293B", margin: 0 }}>
                      <i className="fas fa-calendar-alt mr-2" style={{ color: "#7c3aed" }} />Student Events
                    </h6>
                    <Form.Group className="customDate mb-0" controlId="StartDate" style={{ width: 200 }}>
                      <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end} data="student_Permission" />
                    </Form.Group>
                  </div>

                  {uniqueEventsDates.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="perm-event-table table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th rowSpan="2">#</th>
                            <th rowSpan="2">Date</th>
                            <th rowSpan="2">Event Name</th>
                            <th rowSpan="2">Total</th>
                            <th colSpan="2">In Campus</th>
                            <th colSpan="2">Return to Campus</th>
                          </tr>
                          <tr>
                            <th>Present</th>
                            <th>Exited</th>
                            <th>Returned</th>
                            <th>Not Back</th>
                          </tr>
                        </thead>
                        <tbody>
                          {uniqueEventsDates.map((item, index) => {
                            const date = moment.unix(item).format("DD-MM-YYYY");
                            const evtRow = eventData.find(i => i.from_datetime == item);
                            const total = eventData.filter(i => i.from_datetime == item).length;
                            const present = eventData.filter(i => i.from_datetime == item && (!i.outtime || i.outtime === "")).length;
                            const exited = eventData.filter(i => i.from_datetime == item && i.outtime && i.outtime !== "").length;
                            const returned = eventData.filter(i => i.from_datetime == item && i.intime && i.intime !== "" && i.outtime && i.outtime !== "").length;
                            const notBack = eventData.filter(i => i.from_datetime == item && (!i.intime || i.intime === "") && i.outtime && i.outtime !== "").length;
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ whiteSpace: "nowrap" }}>{date}</td>
                                <td style={{ fontWeight: 600 }}>{evtRow ? evtRow.request_title : "--"}</td>
                                <td className="event-cell cell-total"
                                  onClick={() => this.openPermissionNotifyModal(eventData.filter(i => i.from_datetime == item), "Holiday Hostel Pickup!")}>
                                  {total}
                                </td>
                                <td className="event-cell cell-present"
                                  onClick={() => this.openPermissionNotifyModal(eventData.filter(i => i.from_datetime == item && (!i.outtime || i.outtime === "")), "Urgent: Hostel Pickup Reminder")}>
                                  {present}
                                </td>
                                <td className="event-cell cell-exited"
                                  onClick={() => this.openPermissionNotifyModal(eventData.filter(i => i.from_datetime == item && i.outtime && i.outtime !== ""), "Important: Child Vacation Departure & Home Arrival Check")}>
                                  {exited}
                                </td>
                                <td className="event-cell cell-returned"
                                  onClick={() => this.openPermissionNotifyModal(eventData.filter(i => i.from_datetime == item && i.intime && i.intime !== "" && i.outtime && i.outtime !== ""), "Important: Child Vacation College Arrival Check")}>
                                  {returned}
                                </td>
                                <td className="event-cell cell-out"
                                  onClick={() => this.openPermissionNotifyModal(eventData.filter(i => i.from_datetime == item && (!i.intime || i.intime === "") && i.outtime && i.outtime !== ""), "Action Required: Ward Return Post Holiday Break")}>
                                  {notBack}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="perm-empty-state">
                      <div className="perm-empty-icon"><i className="fas fa-calendar-times" /></div>
                      <p>No event data found for the selected filters and date range.</p>
                    </div>
                  )}
                </>
              ) : (
                /* ── Permission status view ── */
                <>
                  {/* Status cards (hidden for college requests — those are granted directly) */}
                  {!isCollegeView && (
                  <Row className="mb-3">
                    {statusCards.map((c) => {
                      const active = this.state.blockType == c.key;
                      return (
                        <Col xl={4} lg={4} md={4} sm={12} className="mb-2" key={c.key}>
                          <div
                            onClick={() => this.setState({ blockType: c.key })}
                            style={{
                              background: c.tint,
                              border: `1.5px solid ${active ? c.color : c.border}`,
                              borderRadius: 14,
                              padding: "16px 18px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              boxShadow: active ? `0 4px 14px ${c.tint}` : "none",
                              transition: "all .15s ease",
                            }}
                          >
                            <div style={{ textAlign: "left" }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>{c.label}</div>
                              <div style={{ fontSize: 26, fontWeight: 800, color: c.color, lineHeight: 1.1 }}>{c.count}</div>
                            </div>
                            <i className={c.icon} style={{ fontSize: 26, color: c.color, opacity: 0.75 }} />
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  )}

                  {/* Data table */}
                  <div className="perm-table-card">
                    {statusTableRows.length > 0 ? (
                      <CardLessDataTableWithSearch
                        parentData={this.tableData(statusTableRows).sort((a, b) => (b.id || 0) - (a.id || 0))}
                        particlecolumns={this.articlecolumns}
                        name="attendance"
                        leftContent={isCollegeView ? (
                          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#f5f3ff", border: "1.5px solid #ddd6fe", borderRadius: 10, padding: "8px 14px" }}>
                            <i className="fas fa-clipboard-check" style={{ color: "#7c3aed" }} />
                            <span style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>Total Requests:</span>
                            <span style={{ fontSize: 16, fontWeight: 800, color: "#7c3aed" }}>{statusTableRows.length}</span>
                          </div>
                        ) : undefined}
                      />
                    ) : (
                      <div className="perm-empty-state">
                        <div className="perm-empty-icon"><i className="fas fa-inbox" /></div>
                        <p>No permission records found for the selected filters.</p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

          </div>
        </Container>

        {/* ── Modals ── */}
        <PermissionDetailsModal
          stateData={this.state}
          show={this.state.viewDetailsModal}
          onHide={() => this.setState({ viewDetailsModal: false })}
        />
        <SingleRequestModal
          stateData={this.state}
          show={this.state.viewSingleRequestModal}
          onHide={() => this.setState({ viewSingleRequestModal: false })}
          getParentsPermissionDetails={this.props.getParentsPermissionDetails}
          refetchPermissions={this.props.refetchPermissions}
        />
        {/* Multi Request modal hidden per requirement
        <MultipleRequestModal
          stateData={this.state}
          show={this.state.viewMultipleRequestModal}
          onHide={() => this.setState({ viewMultipleRequestModal: false })}
          branches={this.state.branches}
          getClasses={this.state.getClasses}
          getParentsPermissionDetails={this.props.getParentsPermissionDetails}
        />
        */}
        <PermissionModal
          stateData={this.state}
          show={this.state.permissionModalShow}
          onHide={() => this.setState({ permissionModalShow: false })}
        />

        {/* Shown instead of opening the create / approve / notify modals when the
            grant is missing. One modal serves every intercepted action. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    )
  }
}

export default withApollo(StudentPermissionHome);
